// TODO: replace enum with values returned from API
export const ASSET_CLASSES = {
  balanced: 'Balanced',
  equities: 'Equities',
  fixedIncome: 'Fixed income',
  guaranteed: 'Guaranteed',
  international: 'International',
  moneyMarket: 'Money Market',
  multiAsset: 'Multi-Asset',
  none: 'None',
  other: 'Other',
  realEstate: 'Real Estate',
  sectorSpecific: 'Sector Specific',
  targetDate: 'Target Date',
  usEquity: 'U.S. Equity'
};

const assetClassByAssetClassRawLower = {
  balanced: ASSET_CLASSES.balanced,
  equities: ASSET_CLASSES.equities,
  'fixed income': ASSET_CLASSES.fixedIncome,
  guaranteed: ASSET_CLASSES.guaranteed,
  international: ASSET_CLASSES.international,
  'money market': ASSET_CLASSES.moneyMarket,
  'multi-asset': ASSET_CLASSES.multiAsset,
  none: ASSET_CLASSES.none,
  other: ASSET_CLASSES.other,
  'real estate': ASSET_CLASSES.realEstate,
  'sector specific': ASSET_CLASSES.sectorSpecific,
  'target date': ASSET_CLASSES.targetDate,
  'u.s. equity': ASSET_CLASSES.usEquity
};

const getAssetClass = (assetClassRaw = '') =>
  assetClassByAssetClassRawLower[assetClassRaw.toLowerCase()] ||
  ASSET_CLASSES.none;

export default getAssetClass;
